// extracted by mini-css-extract-plugin
export default {"topicPageWrapper":"topicPageStyles_topicPageWrapper__j2SMq"};